import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=5d5bfca0&scoped=true&"
import script from "./MetricCard.vue?vue&type=script&lang=js&"
export * from "./MetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=5d5bfca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5bfca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5bfca0')) {
      api.createRecord('5d5bfca0', component.options)
    } else {
      api.reload('5d5bfca0', component.options)
    }
    module.hot.accept("./MetricCard.vue?vue&type=template&id=5d5bfca0&scoped=true&", function () {
      api.rerender('5d5bfca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stats/MetricCard.vue"
export default component.exports